import { mapGetters } from 'vuex';
import CheckoutSubmitter from '@/utils/checkout-submitter'
import { threeDSHandler, threeDSHandlerWithMandate } from '@/models/three-ds-handler';
import PaymentMixin from '@/mixins/payment-mixin'
import CBNotification from "@/models/cb-notification"
import { EventBus } from '@/utils/event-bus';
import { UpperCaseGateway } from '@/models/gateway-type';
import CbError from "@/utils/cb-error";

export default {
  mixins: [PaymentMixin],
  computed: {
    ...mapGetters([
      'pm_at_subscription_level',
      'authenticated',
      'subscription_handle',
      'is_checkout_gift',
      'threeDSNeeded',
      'intentFlowEnabled',
      'is_checkout_new',
      'is_ideal_payment',
      'is_sofort_payment',
      'is_bancontact_payment',
      'is_google_payment',
      'is_applepay_payment',
      'is_giropay_payment',
      'is_upi_payment',
      'is_direct_debit_payment',
      'is_netbanking_emandate_payment',
      'is_online_banking_poland_payment',
      'is_checkout_one_time',
      'is_paypal_payment',
      'is_boleto_payment',
      'is_venmo_payment',
      'is_instant_direct_debit',
      'is_klarna_pay_now_payment',
      'retain_pm_option'
    ])
  },
  methods: {
    autoSubmit() {
      if(this.$store.getters.selected_payment_method?.transient) {
        const pmType = this.$store.getters.selected_payment_method.type
        const pm = this.$store.getters.pm_by_type(pmType);
        let autoSubmit = pm?.skip_pay_button_click;
        if(pm?.skip_pay_button_click) {
          if(this.hosted_page_type == "checkout" && this.is_checkout_one_time) {
            autoSubmit = this.retain_pm_option !="ASK_CUSTOMER";
          } else if(this.hosted_page_type == "paynow") {
            autoSubmit = false;
          }
        }
        if(autoSubmit) {
          this.submit()
        }
      }
		},
    getPromiseWrapper() {
      var promiseWrapper;
      if(this.is_checkout_new) {
        promiseWrapper = this.submitCheckoutNew();
      }
      else if(this.is_checkout_gift) {
        promiseWrapper = this.submitForGift();
      } else if (this.is_checkout_one_time) {
        promiseWrapper = this.submitCheckoutOneTime();
      }
      else {
        promiseWrapper = this.submitCheckoutExisting();
      }
      return promiseWrapper;
    },

    _submit() {
      this.showLoader = true;
      return this.getPromiseWrapper().then((data) => {
        if (!data.extra_info || !data.extra_info.redirect_url) {
          this.showLoader = false;
        }
        this.$store.dispatch('set_recaptcha_checkout',false)
        this.openThankYouPage(data);
      })
      .catch((error) => {
        this.showLoader = false;
        if (error.type) {
          this.highlightSection = error.type;
        } else {
          // TODO different error format for gift
          if(!this.is_checkout_gift) {
            this.highlightSection = "subscription";
            error.type = "subscription";
          }
        }
        if (error.detail && error.detail.error_cause_id && this.$store.getters.get_text(error.detail.error_cause_id)) {
          this.$store.dispatch('set_current_notification',
            new CBNotification('error', {
              message: this.$store.getters.get_text(error.detail.error_cause_id) || error.message, 
              isDismissible: true
            })
          );
        }
        else if(error.code === 'ChargebeeClientError') {
          this.$store.dispatch('set_current_notification',
            new CBNotification('error', {
              message: error.message,
              isDismissible: true
            })
          );
        }  else {
          this.$store.dispatch('set_current_notification', new CBNotification('error', error));
        }
        EventBus.$emit('hp_log', {action:'checkout_failed', error});
        logger.e(error);
      })
    },

    newCheckoutSubmitter() {
      return new CheckoutSubmitter(this.$store.state, this.$store.getters, this.$store.dispatch);
    },

    submitCheckoutNew() {
      const checkoutSubmitter = this.newCheckoutSubmitter();
      return Promise.resolve().then(() => {
        if (this.is_ideal_payment) {
          return checkoutSubmitter.submitCheckoutNew(true).then((postActionJson) => this.submitIDealCheckoutWithPostAction(postActionJson))
        }
        else if (this.is_sofort_payment) {
          return this.submitSofortCheckout()
        }
        else if (this.is_bancontact_payment) {
          return this.submitBancontactCheckout();
        }
        else if (this.is_google_payment) {
          return this.submitGooglePayCheckout();
        }
        else if (this.is_applepay_payment || this.is_paypal_payment || this.is_venmo_payment) {
          return this.submitPreAuthorizedCheckout();
        }
        else if (this.is_giropay_payment) {
          return this.submitGiropayCheckout();
        }
        else if (this.is_upi_payment) {
          return this.submitUpiCheckout()
        }
        else if(this.is_direct_debit_payment && this.isDirectDebitPaymentIntentSupported(this.$store.state.order.payment_method)) {
          return this.submitDirectDebitCheckout(this.$store.state.order.payment_method);
        }
        else if(this.is_instant_direct_debit && this.isInstantBankPaymentIntentSupported(this.$store.state.order.payment_method)) {
          return this.isInAppInstantBankAccountPaymentMethod(this.$store.state.order.payment_method.type)
                    ? this.submitInAppInstantBanking(this.$store.state.order.payment_method) : this.submitPreAuthorizedCheckout();
        }
        else if(this.threeDSNeeded || this.intentFlowEnabled) {
          return threeDSHandlerWithMandate(this.$store, this.$store.state.order.payment_method);
        }
        else if(this.is_netbanking_emandate_payment) {
          return this.submitNetbankingEmandate();
        }
        else if (this.is_boleto_payment) {
          return this.submitVoucherCheckout();
        } else if(this.is_klarna_pay_now_payment){
          return this.submitKlarnaPayNowCheckout();
        } else if(this.is_online_banking_poland_payment) {
          return this.submitOnlineBankingPoland();
        }
        else {
          this.$store.dispatch("set_payment_intent", undefined)
        }
      }).then(() => {
        if (!this.is_ideal_payment || !this.$store.getters.redirect_ideal_from_post_payment) {
          return this.newCheckoutSubmitter().submitCheckoutNew();
        }
        else {
          return this.delayedSubmitCheckout();
        }
      }
    );
    },

    submitCheckoutOneTime() {
      const checkoutSubmitter = this.newCheckoutSubmitter();
      return Promise.resolve().then(() => {
        if (this.is_ideal_payment) {
          return checkoutSubmitter.submitCheckoutOneTime(true).then((postActionJson) => this.submitIDealCheckoutWithPostAction(postActionJson))
        }
        else if (this.is_sofort_payment) {
          return this.submitSofortCheckout()
        }
        else if (this.is_bancontact_payment) {
          return this.submitBancontactCheckout();
        }
        else if (this.is_google_payment) {
          return this.submitGooglePayCheckout();
        }
        else if (this.is_applepay_payment || this.is_paypal_payment || this.is_venmo_payment || this.isIn) {
          return this.submitPreAuthorizedCheckout();
        }
        else if (this.is_giropay_payment) {
          return this.submitGiropayCheckout();
        }
        else if(this.is_netbanking_emandate_payment) {
          return this.submitNetbankingEmandate();
        }
        else if (this.is_upi_payment) {
          return this.submitUpiCheckout()
        }
        else if(this.is_direct_debit_payment && this.isDirectDebitPaymentIntentSupported(this.$store.state.order.payment_method)) {
          return this.submitDirectDebitCheckout(this.$store.state.order.payment_method);
        }

        else if(this.is_instant_direct_debit && this.isInstantBankPaymentIntentSupported(this.$store.state.order.payment_method)) {
          return this.isInAppInstantBankAccountPaymentMethod(this.$store.state.order.payment_method.type)
                    ? this.submitInAppInstantBanking(this.$store.state.order.payment_method) : this.submitPreAuthorizedCheckout();
        }
        else if(this.threeDSNeeded || this.intentFlowEnabled) {
          return threeDSHandler(this.$store, this.$store.state.order.payment_method);
        }
        else if (this.is_boleto_payment) {
          return this.submitVoucherCheckout();
        }
        else if(this.is_klarna_pay_now_payment){
          return this.submitKlarnaPayNowCheckout();
        }
        else if(this.is_online_banking_poland_payment) {
          return this.submitOnlineBankingPoland();
        }
        else {
          this.$store.dispatch("set_payment_intent", undefined)
        }
      }).then(() => this.newCheckoutSubmitter().submitCheckoutOneTime());
    },

    submitCheckoutExisting() {
      const checkoutSubmitter = this.newCheckoutSubmitter();
      return Promise.resolve().then(() => {
        if (this.is_ideal_payment) {
          return checkoutSubmitter.submitCheckoutExisting(true).then((postActionJson) => this.submitIDealCheckoutWithPostAction(postActionJson))
        }
        else if (this.is_sofort_payment) {
          return this.submitSofortCheckout()
        }
        else if (this.is_bancontact_payment) {
          return this.submitBancontactCheckout();
        }
        else if (this.is_google_payment) {
          return this.submitGooglePayCheckout();
        }
        else if (this.is_applepay_payment || this.is_paypal_payment || this.is_venmo_payment) {
          return this.submitPreAuthorizedCheckout();
        }
        else if (this.is_giropay_payment) {
          return this.submitGiropayCheckout();
        }
        else if(this.is_netbanking_emandate_payment) {
          return this.submitNetbankingEmandate();
        }
        else if (this.is_upi_payment) {
          return this.submitUpiCheckout()
        }
        else if(this.is_direct_debit_payment && this.isDirectDebitPaymentIntentSupported(this.$store.state.order.payment_method)) {
          return this.submitDirectDebitCheckout(this.$store.state.order.payment_method);
        }
        else if(this.is_instant_direct_debit && this.isInstantBankPaymentIntentSupported(this.$store.state.order.payment_method)) {
          return this.isInAppInstantBankAccountPaymentMethod(this.$store.state.order.payment_method.type)
                    ? this.submitInAppInstantBanking(this.$store.state.order.payment_method) : this.submitPreAuthorizedCheckout();
        }
        else if(this.threeDSNeeded || this.intentFlowEnabled) {
          return threeDSHandlerWithMandate(this.$store, this.$store.state.order.payment_method);
        }
        else if (this.is_boleto_payment) {
          return this.submitVoucherCheckout();
        }
        else if(this.is_klarna_pay_now_payment){
          return this.submitKlarnaPayNowCheckout();
        }
        else if(this.is_online_banking_poland_payment) {
          return this.submitOnlineBankingPoland();
        }
        else {
          this.$store.dispatch("set_payment_intent", undefined)
        }
      }).then(() => this.newCheckoutSubmitter().submitCheckoutExisting());
    },

    submitForGift() {
      return Promise.resolve().then(() => {
        if (this.is_ideal_payment) {
          return this.loadAndSubmitGift(true).then((postActionJson) => this.submitIDealCheckoutWithPostAction(postActionJson))
        }
        else if (this.is_sofort_payment) {
          return this.submitSofortCheckout()
        }
        else if (this.is_bancontact_payment) {
          return this.submitBancontactCheckout()
        }
        else if (this.is_google_payment) {
          return this.submitGooglePayCheckout();
        }
        else if (this.is_applepay_payment || this.is_paypal_payment || this.is_venmo_payment) {
          return this.submitPreAuthorizedCheckout();
        }
        else if (this.is_giropay_payment) {
          return this.submitGiropayCheckout();
        }
        else if(this.is_netbanking_emandate_payment) {
          return this.submitNetbankingEmandate();
        }
        else if (this.is_upi_payment) {
          return this.submitUpiCheckout()
        }
        else if(this.is_direct_debit_payment && this.isDirectDebitPaymentIntentSupported(this.$store.state.order.payment_method)) {
          const gateway = this.$store.state.order?.payment_method?.gateway_name;
          /*
            Generally this validation is done by the API for other ACH gateways.
            As an exception we are doing this at the UI here for Braintree. Due to,
              This fails at the pre processing stage at Braintree JS SDK while tokenizing itself since
              Gift subs do not have a billingAddress.
              Now there is a different error thrown. We wanted to unify the error message thrown across gateways,
              so validating for Braintree specifically before invoking handlepayment as a workaround.
          */
          if (gateway === UpperCaseGateway.BRAINTREE) {
            return Promise.reject(new CbError(400, { message: "Only immediate payment is supported for gift." }));
          }
          return this.submitDirectDebitCheckout(this.$store.state.order.payment_method);
        }
        else if(this.is_instant_direct_debit && this.isInstantBankPaymentIntentSupported(this.$store.state.order.payment_method)) {
          return this.isInAppInstantBankAccountPaymentMethod(this.$store.state.order.payment_method.type)
                    ? this.submitInAppInstantBanking(this.$store.state.order.payment_method) : this.submitPreAuthorizedCheckout();
        }
        else if(this.threeDSNeeded || this.intentFlowEnabled) {

          return threeDSHandlerWithMandate(this.$store, this.$store.state.order.payment_method);
        }
        else if (this.is_boleto_payment) {
          return this.submitVoucherCheckout();
        }
        else if(this.is_klarna_pay_now_payment){
          return this.submitKlarnaPayNowCheckout();
        } else if(this.is_online_banking_poland_payment) {
          return this.submitOnlineBankingPoland();
        }
        else {
          this.$store.dispatch("set_payment_intent", undefined)
        }
      }).then(() => this.loadAndSubmitGift());
    },

    loadAndSubmitGift(postAction = false) {
      return import(/* webpackChunkName: "checkout-gift-submitter" */"@/utils/gift-submitter")
      .then(module => {
        let GiftSubmitter = module.default;
        let giftSubmitter = new GiftSubmitter(this.$store.state, this.$store.getters, this.$store.dispatch);
        if(!this.authenticated) {
          return !this.gift_receiver.existing ? giftSubmitter.handleNewGifterNewReceiver(postAction) : giftSubmitter.handleNewGifterExistingReceiver(postAction);
        }
        else {
          return !this.gift_receiver.existing ? giftSubmitter.handleExistingGifterNewReceiver(postAction) : giftSubmitter.handleExistingGifterExistingReceiver(postAction);
        }
      });
    },

    isGifterAndRecieverSame(){
      if (!this.is_checkout_gift) {
        return false;
      }
      if(this.authenticated) {
        return this.$store.state.customer.data.id == this.gift_receiver.handle;
      }
      else {
        return this.gift_receiver.existing ? false : (this.$store.state.customer.data.email && (this.$store.state.customer.data.email == this.gift_receiver.data.email));
      }
    },
    allowSubmitFromBrowser () {
      return this.$store.getters.redirect_ideal_from_post_payment && !document.hidden;
    },
    delayedSubmitCheckout() {
      return new Promise((resolve) => {
        setTimeout(() => {
          if (this.allowSubmitFromBrowser()) {
            resolve(this.newCheckoutSubmitter().submitCheckoutNew());
          } else {
            resolve();
          }
        }, 1000);
      });
    }
  }
}
